import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * Floating "back to top" pill. Fades in after the user has scrolled a bit.
 * Non-invasive: pointer-events off when hidden, print-hidden.
 */
export default function ScrollToTopButton({ threshold = 500, testid = "scroll-top-btn" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      data-testid={testid}
      className={`no-print fixed bottom-6 right-6 z-40 h-11 w-11 rounded-full bg-navy text-white shadow-lg ring-2 ring-[hsl(var(--gold))]/60 grid place-items-center transition-opacity duration-200 hover:bg-navy/90 ${
        visible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-5 h-5" strokeWidth={2} />
    </button>
  );
}
